import React, { useState } from 'react';

function Logo({ className = "", width = "220", height = "60", idSuffix = "" }) {
  const [videoError, setVideoError] = useState(false);

  // Fallback SVG si la vidéo ne charge pas
  const SvgFallback = () => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 220 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Définition des dégradés */}
      <defs>
        <linearGradient id={`blueGradient${idSuffix}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{stopColor:'#7000FF', stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:'#3a0ca3', stopOpacity:1}} />
        </linearGradient>
        <linearGradient id={`accentGradient${idSuffix}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{stopColor:'#00C6FF', stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:'#0072ff', stopOpacity:1}} />
        </linearGradient>
      </defs>

      {/* Forme hexagonale moderne (icône tech) */}
      <g transform="translate(8, 15)">
        {/* Hexagone de fond */}
        <path d="M15 5 L25 10 L25 20 L15 25 L5 20 L5 10 Z" fill={`url(#blueGradient${idSuffix})`} opacity="0.15"/>

        {/* Hexagone principal avec bordure */}
        <path d="M15 7 L23 11.5 L23 18.5 L15 23 L7 18.5 L7 11.5 Z"
              stroke={`url(#blueGradient${idSuffix})`}
              strokeWidth="2.5"
              fill="none"
              strokeLinejoin="round"/>

        {/* Connexions tech (lignes sortantes) */}
        <line x1="15" y1="7" x2="15" y2="2" stroke={`url(#accentGradient${idSuffix})`} strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="23" y1="11.5" x2="28" y2="9" stroke={`url(#accentGradient${idSuffix})`} strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="23" y1="18.5" x2="28" y2="21" stroke={`url(#accentGradient${idSuffix})`} strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="15" y1="23" x2="15" y2="28" stroke={`url(#accentGradient${idSuffix})`} strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="7" y1="18.5" x2="2" y2="21" stroke={`url(#accentGradient${idSuffix})`} strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="7" y1="11.5" x2="2" y2="9" stroke={`url(#accentGradient${idSuffix})`} strokeWidth="2.5" strokeLinecap="round"/>

        {/* Point central lumineux */}
        <circle cx="15" cy="15" r="3" fill={`url(#blueGradient${idSuffix})`}/>
        <circle cx="15" cy="15" r="1.5" fill="white"/>
      </g>

      {/* Texte OLNEY avec style moderne */}
      <text x="48" y="28"
            fontFamily="'Space Grotesk', sans-serif"
            fontSize="22"
            fontWeight="700"
            fill="white"
            letterSpacing="1">
        OLNEY
      </text>

      {/* Ligne séparatrice stylée */}
      <path d="M 48 32 Q 73 34 98 32"
            stroke={`url(#accentGradient${idSuffix})`}
            strokeWidth="2"
            fill="none"
            opacity="0.6"/>

      {/* Texte Tech Solutions */}
      <text x="48" y="46"
            fontFamily="'Space Grotesk', sans-serif"
            fontSize="11"
            fontWeight="600"
            fill="#94A3B8"
            letterSpacing="2">
        TECH SOLUTIONS
      </text>

      {/* Badge "NORD" petit accent local */}
      <g transform="translate(165, 18)">
        <rect width="45" height="18" rx="9" fill={`url(#accentGradient${idSuffix})`} opacity="0.15"/>
        <rect x="0.5" y="0.5" width="44" height="17" rx="8.5"
              stroke={`url(#accentGradient${idSuffix})`}
              strokeWidth="1"
              fill="none"/>
        <text x="22.5" y="12.5"
              fontFamily="'Space Grotesk', sans-serif"
              fontSize="8"
              fontWeight="700"
              fill="white"
              textAnchor="middle">
          NORD
        </text>
      </g>
    </svg>
  );

  // Si erreur vidéo, afficher le fallback SVG
  if (videoError) {
    return <SvgFallback />;
  }

  return (
    <video
      width={width}
      height={height}
      autoPlay
      loop
      muted
      playsInline
      className={className}
      onError={() => setVideoError(true)}
      style={{ objectFit: 'contain' }}
    >
      {/* WebM pour meilleure qualité et compression */}
      <source src={`${process.env.PUBLIC_URL}/logo-animated.webm`} type="video/webm" />
      {/* MP4 comme fallback pour compatibilité */}
      <source src={`${process.env.PUBLIC_URL}/logo-animated.mp4`} type="video/mp4" />
      {/* Fallback SVG si aucune vidéo ne charge */}
      <SvgFallback />
    </video>
  );
}

export default Logo;